import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import moment from "moment";
import { request, sleep } from "@/js/http/http_request";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { regexbAbsoluteUri } from "@/js/regexp_validation.js";
import { formRules } from "@/js/form_rules.js";
import { wineNaming } from "@/js/wine/wine.js";
import { orderStatus, orderTypes, expeditionMethods } from "@/js/lists.ts";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import OrderShipmentList from "@/components/order/AdminSummarySubs/OrderShipmentsList.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Confirm: Confirm,
    MailTemplateModal: MailTemplateModal,
    MailTemplateForm: MailTemplateForm,
    OrderShipmentList: OrderShipmentList,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    order: {
      type: Object,
      default: {}
    },
    customerComplete: Object,
    canBePricePostingUsaProSubmitted: Boolean,
    importersAvailable: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      URL: URL,
      drawerWidth: "45%",
      drawer: false,
      isStatelessDrawer: true,
      documents: [],
      isSuccessfulSending: {},
      hasFailedSending: false,
      failedCustomMails: {},
      isLoadingFiles: false,
      isSyncing: false,
      isNeedingSync: false,
      isDeletingTemplate: false,
      templateModalShown: false,
      editableTemplate: {},
      panels: [],
      openedPanel: 0,
      emailPlaceholders: {},
      emailTemplates: [],
      form: {
        slots: {},
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }]
      },
      isSendNotificationMails: true,
      isSendNotificationMailsToImporter: false,
      isAutoStatusContainerSuborders: true,
      availableOrders: [],
      steps: [],
      defaultSteps: [],
      currentStep: 1,
      ttbStepTip: null,
      slots: [],
      isValidatingOrder: false,
      isFillingNewCarrier: false,
      isDeletingCarrier: [],
      isCreatingCarrier: false,
      isCheckingTtb: false,
      errorOccurred: false,
      isCopyingToClipboard: false,
      isEditingImporter: false,
      importerSelectorSelected: null,
      changeOrderImporterCancellationToken: null,
      changeExpeditionMethodToken: null,
      calculateOrderAmountsToken: null,
      showDetailsOfItemsProvenanceAboutInvoice: false,
      managedExceptions: {
        error: {
          invalid_expedition_method: "Invalid expedition method"
        }
      },
      expeditionMethods: expeditionMethods,
      rules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    allSlotsOk: function allSlotsOk() {
      return Object.values(this.form.slots).filter(function (x) {
        return !!x;
      });
    },
    isInvalidMainForm: function isInvalidMainForm() {
      if (this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && this.allSlotsOk.length !== this.availableOrders.length) return true;
      if (this.isExportedToUSA && this.winesWithoutTtbId.length) return true;
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      return false;
    },
    errorsMainForm: function errorsMainForm() {
      if (this.isInvalidMainForm) {
        var _this$order$importer;
        var errors = [];
        if (this.isExportedToUSA && this.winesWithoutTtbId.length) errors.push("Some TTB ids are still missing.");
        if (this.hasImporter && !((_this$order$importer = this.order.importer) !== null && _this$order$importer !== void 0 && _this$order$importer.id)) errors.push("You must choose the importer.");
        if (this.allSlotsOk.length !== this.availableOrders.length && this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id) errors.push("You must plan a valid pickup.");
        var nullishPredicate = function nullishPredicate(x) {
          var _x$sendTo2;
          return !x.id || !x.from || !((_x$sendTo2 = x.sendTo) !== null && _x$sendTo2 !== void 0 && _x$sendTo2.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
        };
        if (this.form.emailTemplates.some(nullishPredicate)) errors.push("At least one mail configured is still not set correctly. You should delete it, or configure it completely.");
        return errors;
      }
      return null;
    },
    isExportedToUSA: function isExportedToUSA() {
      return this.order.delivery_address.country.iso_2 === "US";
    },
    winesWithoutTtbId: function winesWithoutTtbId() {
      return this.order.items.map(function (x) {
        return x.wine;
      }).filter(function (x) {
        return !x.ttbId;
      });
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    },
    hasImporter: function hasImporter() {
      return this.importersAvailable.length > 0;
    },
    canEditImporter: function canEditImporter() {
      return this.importersAvailable.length > 1 && !this.order.isImporterInvoiced;
    },
    importerSelectedHasMail: function importerSelectedHasMail() {
      return this.hasImporter && !String.isNullOrEmpty(this.importerSelectorSelected.mailContact);
    },
    isContainerOrder: function isContainerOrder() {
      return this.order.type === orderTypes.CONTAINER;
    },
    isContainerOrderOrLinkedToContainerOrder: function isContainerOrderOrLinkedToContainerOrder() {
      var _this$order$parentCon;
      return this.isContainerOrder || ((_this$order$parentCon = this.order.parentContainerOrder) === null || _this$order$parentCon === void 0 ? void 0 : _this$order$parentCon.id_order) > 0;
    },
    itemsProvenanceFromOrder: function itemsProvenanceFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart;
          return ((_p$stockPart = p.stockPart) === null || _p$stockPart === void 0 || (_p$stockPart = _p$stockPart.fromOrderData) === null || _p$stockPart === void 0 ? void 0 : _p$stockPart.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart;
            return ((_provenance$stockPart = provenance.stockPart) === null || _provenance$stockPart === void 0 || (_provenance$stockPart = _provenance$stockPart.fromOrderData) === null || _provenance$stockPart === void 0 ? void 0 : _provenance$stockPart.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    itemsProvenanceNotFromOrder: function itemsProvenanceNotFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart2;
          return !((_p$stockPart2 = p.stockPart) !== null && _p$stockPart2 !== void 0 && (_p$stockPart2 = _p$stockPart2.fromOrderData) !== null && _p$stockPart2 !== void 0 && _p$stockPart2.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart2;
            return !((_provenance$stockPart2 = provenance.stockPart) !== null && _provenance$stockPart2 !== void 0 && (_provenance$stockPart2 = _provenance$stockPart2.fromOrderData) !== null && _provenance$stockPart2 !== void 0 && _provenance$stockPart2.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    hasWarningItemsProvenanceAboutInvoice: function hasWarningItemsProvenanceAboutInvoice() {
      var _this$itemsProvenance, _this$itemsProvenance2;
      return !this.isContainerOrderOrLinkedToContainerOrder && (this.order.isPreventInvoice && ((_this$itemsProvenance = this.itemsProvenanceNotFromOrder) === null || _this$itemsProvenance === void 0 ? void 0 : _this$itemsProvenance.length) > 0 || !this.order.isPreventInvoice && ((_this$itemsProvenance2 = this.itemsProvenanceFromOrder) === null || _this$itemsProvenance2 === void 0 ? void 0 : _this$itemsProvenance2.length) > 0);
    },
    hasWarningAboutPricePostingUsed: function hasWarningAboutPricePostingUsed() {
      var _this$customerComplet;
      if (!this.canBePricePostingUsaProSubmitted) return false;
      if (this.customerComplete && !this.customerComplete.IsPricePostingUsaProSubmittedByLaw) return false;
      if ((_this$customerComplet = this.customerComplete) !== null && _this$customerComplet !== void 0 && _this$customerComplet.IsPricePostingUsaProSubmittedByLaw && !this.order.pricePostingUsaPro) return true;
      if (this.form.slots[this.order.id_order]) {
        if (!this.order.pricePostingUsaPro) return false;
        var pickUpDate = moment(this.form.slots[this.order.id_order]);
        var estimatedDeliveryDays = this.order.eta_max_hours ? Math.ceil(this.order.eta_max_hours / 24) : Math.ceil(this.order.eta_min_hours / 24);
        var estimatedDeliveryDate = pickUpDate.clone().add(estimatedDeliveryDays, "days");
        var pricePostingUsaProDate = moment(this.order.pricePostingUsaPro.applicationDate);
        return !pricePostingUsaProDate.isSame(estimatedDeliveryDate, "month");
      }
      return false;
    },
    warningAboutPricePostingUsedHtml: function warningAboutPricePostingUsedHtml() {
      var _this$order$pricePost;
      var rawListDate = (_this$order$pricePost = this.order.pricePostingUsaPro) === null || _this$order$pricePost === void 0 ? void 0 : _this$order$pricePost.applicationDate;
      var listMonth = rawListDate ? moment(String(rawListDate)).format("MMMM YYYY") : "No one";
      var rawPickupDate = this.form.slots[this.order.id_order];
      var estimatedDeliveryDays = this.order.eta_max_hours ? Math.ceil(this.order.eta_max_hours / 24) : Math.ceil(this.order.eta_min_hours / 24);
      var estimatedDeliveryDate = rawPickupDate ? moment(String(rawPickupDate)).add(estimatedDeliveryDays, "days") : "";
      var estimatedDeliveryMonth = estimatedDeliveryDate ? moment(String(estimatedDeliveryDate)).format("MMMM YYYY") : "";
      var html = "The estimated delivery date month (".concat(estimatedDeliveryMonth, ") does not match the currently selected price posting month (").concat(listMonth, ").<br />") + "Please update the price posting on the main screen before submitting the preparation request.<br />" + "Click here to change the selected price posting month.";
      return html;
    }
  },
  watch: {
    isShown: function () {
      var _isShown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(visible) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.drawer = visible;
              this.closureAttempt = 0;
              if (this.hasImporter) {
                this.isEditingImporter = false;
              }
              if (visible) {
                if (!this.defaultSteps.length) {
                  this.defaultSteps = _toConsumableArray(this.steps.map(function (x) {
                    return _objectSpread({}, x);
                  }));
                }
                this.initStep();
                this.fetchPickupAvailabilities();
                this.fetchEmailPlaceholders();
                this.fetchEmailTemplates();
                this.fetchOrderDocuments();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isShown(_x) {
        return _isShown.apply(this, arguments);
      }
      return isShown;
    }(),
    currentStep: function currentStep(_currentStep) {
      if (this.steps.length > 0 && _currentStep === this.steps.find(function (x) {
        return x.key === "mail";
      }).id) {
        this.drawerWidth = "80%";
      } else {
        this.drawerWidth = "45%";
      }
    }
  },
  updated: function updated() {
    this.closureAttempt++;
  },
  methods: {
    fillPlaceholder: function fillPlaceholder(key, symbol, value) {
      if (this.emailPlaceholders[key]) {
        this.emailPlaceholders[key] = _toConsumableArray(this.emailPlaceholders[key].map(function (x) {
          if (x.symbol === symbol) x.filledValue = value;
          return x;
        }));
      }
    },
    inputDate: function inputDate(value) {
      this.fillPlaceholder("Order", "%ShipmentDate%", value);
    },
    changePanel: function changePanel() {
      var _this2 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this2.openedPanel && _this2.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context2.sent;
              if (isConfirmed) {
                _this3.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isSyncing = true;
              _context3.next = 3;
              return _this4.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this4.form.emailTemplates[_this4.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this4.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this4.changeTemplate(current);
              }
              _this4.isSyncing = false;
              _this4.isNeedingSync = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this5 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this5.templateModalShown = false;
      });
    },
    newTemplate: function newTemplate() {
      var _this6 = this;
      this.$nextTick(function () {
        return _this6.templateModalShown = true;
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this7;
              _context4.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this7.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this7.isNeedingSync = true;else _this7.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context5.sent;
              if (!isConfirmed) {
                _context5.next = 14;
                break;
              }
              _this8.isDeletingTemplate = true;
              _this = _this8;
              _context5.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context5.next = 10;
              return _this8.fetchEmailTemplates();
            case 10:
              rest = _this8.form.emailTemplates.filter(function (x) {
                return x.id === templateId;
              });
              _this8.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this8.editableTemplate = {};
              _this8.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this9;
              _context6.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context6.sent;
              _this9.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return request("/v1/mail/placeholders?orderId=".concat(_this10.order.id_order), "get", null, true, "api");
            case 2:
              response = _context7.sent;
              _this10.emailPlaceholders = response.data;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    newEmail: function newEmail() {
      var _this11 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this11.form.emailTemplates.length - 1;
        _this11.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    close: function close() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isConfirmed = true;
              if (!(_this12.order.expedition_method && !_this12.hasFailedSending)) {
                _context8.next = 5;
                break;
              }
              _context8.next = 4;
              return _this12.$refs.confirm.open("Cancel", "Are you sure you want to cancel the preparation ?");
            case 4:
              isConfirmed = _context8.sent;
            case 5:
              if (isConfirmed) {
                _this12.currentStep = 1;
                _this12.steps = _toConsumableArray(_this12.defaultSteps.map(function (x) {
                  return _objectSpread({}, x);
                }));
                _this12.isStatelessDrawer = false;
                _this12.drawer = false;
                _this12.$emit("close", true);
                _this12.isStatelessDrawer = true;
              }
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    checkWhetherAllTtbExists: function checkWhetherAllTtbExists() {
      this.isCheckingTtb = true;
      this.emptyDocuments();
      this.fetchOrderDocuments();
      var _this = this;
      this.$emit("sync", true, function (newOrder) {
        if (!newOrder.items.map(function (x) {
          return x.wine;
        }).filter(function (x) {
          return !x.ttbId;
        }).length) {
          _this.$nextTick(function () {
            _this.currentStep++;
            _this.ttbStepTip = null;
          });
        } else {
          _this.ttbStepTip = "You are still missing ttb identifiers.";
        }
        _this.isCheckingTtb = false;
      });
    },
    planShipment: function planShipment(order) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return request("/v1/shipping", "post", {
                orderId: order.id_order,
                pickupDate: _this13.form.slots[order.id_order]
              }, true, "api");
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    acknowledgeValidation: function acknowledgeValidation() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this14.$emit("validate", true, function () {
                if (!_this14.hasFailedSending) _this14.$emit("close", true);
                _this14.isValidatingOrder = false;
                _this14.$toasted.show("Order succesfully prepared.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    calculateOrderAmounts: function calculateOrderAmounts() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this15$calculateOrde;
        var _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              (_this15$calculateOrde = _this15.calculateOrderAmountsToken) === null || _this15$calculateOrde === void 0 || _this15$calculateOrde.cancel();
              _this15.calculateOrderAmountsToken = axios.CancelToken.source();
              _this = _this15;
              _context11.next = 5;
              return request("/v1/order/".concat(_this15.order.id_order, "/calculate-amounts"), "put", null, true, "api", null, _this15.calculateOrderAmountsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to calculate amounts.");
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    updateExpeditionMethod: function updateExpeditionMethod() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this16$changeExpedit;
        var _this;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              (_this16$changeExpedit = _this16.changeExpeditionMethodToken) === null || _this16$changeExpedit === void 0 || _this16$changeExpedit.cancel();
              _this16.changeExpeditionMethodToken = axios.CancelToken.source();
              _this = _this16;
              _context12.next = 5;
              return request("/v1/order/".concat(_this16.order.id_order, "/expedition-method"), "put", {
                expedition_method: _this.order.expedition_method,
                eta_min_hours: _this.order.eta_min_hours,
                eta_max_hours: _this.order.eta_max_hours
              }, true, "api", null, _this.changeExpeditionMethodToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update expedition method.");
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    fetchOrderLogistic: function fetchOrderLogistic() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this17;
              _context13.next = 3;
              return request("/v1/order/".concat(_this17.order.id_order, "/logistic/"), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get logistic costs.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    validateMain: function validateMain() {
      var _arguments = arguments,
        _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var isConfirmed, fromUpdateStateOrder, _this, mustUpdateExpeditionMethod, data, _loop, i;
        return _regeneratorRuntime().wrap(function _callee17$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              isConfirmed = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              fromUpdateStateOrder = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              if (isConfirmed) {
                _context18.next = 6;
                break;
              }
              _context18.next = 5;
              return _this18.$refs.confirm.open("Order preparation", "Are you sure the order is ready to ship?");
            case 5:
              isConfirmed = _context18.sent;
            case 6:
              if (!isConfirmed) {
                _context18.next = 37;
                break;
              }
              _this = _this18;
              _this18.isValidatingOrder = true;
              if (fromUpdateStateOrder) {
                _context18.next = 13;
                break;
              }
              if (!(_this18.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id)) {
                _context18.next = 13;
                break;
              }
              _context18.next = 13;
              return Promise.all(_this18.availableOrders.map(function (x) {
                return _this18.planShipment(x);
              })).catch(function (e) {
                var _e$response$data2;
                if ((_e$response$data2 = e.response.data) !== null && _e$response$data2 !== void 0 && _e$response$data2.value) {
                  _this.$toasted.show("".concat(_this.reference_order.shorterReference(), ": ").concat(e.response.data.value), {
                    type: "warning"
                  });
                } else {
                  _this.$toasted.show("Unable to plan a shipment for ".concat(_this.reference_order, "."), {
                    type: "error"
                  });
                }
                _this.isValidatingOrder = false;
                throw e;
              });
            case 13:
              mustUpdateExpeditionMethod = false;
              data = {
                send_mails: _this18.isSendNotificationMails,
                notifyImporter: _this18.isSendNotificationMailsToImporter
              };
              if (_this18.isContainerOrder) {
                data.isAutoStatusContainerSuborders = _this18.isAutoStatusContainerSuborders;
              }
              _context18.next = 18;
              return _this18.updateStateOrder(_this18.order, data).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(e) {
                  var _e$response$data3;
                  var errorData, _e$response$data$valu;
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        errorData = getErrorData(e, _this.managedExceptions, "Unable to prepare the order.", true);
                        if ((_e$response$data3 = e.response.data) !== null && _e$response$data3 !== void 0 && _e$response$data3.value) {
                          if ((_e$response$data$valu = e.response.data.value) !== null && _e$response$data$valu !== void 0 && _e$response$data$valu.errorCode) {
                            if (!fromUpdateStateOrder && e.response.data.value.errorCode == "invalid_expedition_method" && !!_this.order.expedition_method) {
                              mustUpdateExpeditionMethod = true;
                            } else {
                              handleErrorData(_this, errorData);
                            }
                          } else {
                            handleErrorData(_this, errorData);
                          }
                        } else {
                          handleErrorData(_this, errorData);
                        }
                        if (mustUpdateExpeditionMethod) {
                          _context14.next = 5;
                          break;
                        }
                        _this.isValidatingOrder = false;
                        throw e;
                      case 5:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 18:
              if (!mustUpdateExpeditionMethod) {
                _context18.next = 28;
                break;
              }
              _context18.next = 21;
              return _this18.fetchOrderLogistic();
            case 21:
              _context18.next = 23;
              return _this18.updateExpeditionMethod();
            case 23:
              _context18.next = 25;
              return _this18.calculateOrderAmounts();
            case 25:
              _context18.next = 27;
              return _this18.validateMain(true, true);
            case 27:
              return _context18.abrupt("return");
            case 28:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      template = _this18.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this18;
                      _context17.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
                        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                          while (1) switch (_context15.prev = _context15.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context15.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context15.stop();
                          }
                        }, _callee15);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e) {
                          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                            while (1) switch (_context16.prev = _context16.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context16.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context16.stop();
                            }
                          }, _callee16);
                        }));
                        return function (_x3) {
                          return _ref3.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context17.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 30:
              if (!(i < _this18.form.emailTemplates.length)) {
                _context18.next = 35;
                break;
              }
              return _context18.delegateYield(_loop(i), "t0", 32);
            case 32:
              i++;
              _context18.next = 30;
              break;
            case 35:
              _this.$emit("stateOrderUpdated");
              _this18.acknowledgeValidation();
            case 37:
            case "end":
              return _context18.stop();
          }
        }, _callee17);
      }))();
    },
    updateStateOrder: function updateStateOrder(order, body) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        return _regeneratorRuntime().wrap(function _callee18$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", request("/v1/order/" + order.id_order + "/state/" + orderStatus.find(function (os) {
                return os.id === "IN_PREPARATION";
              }).status, "put", body, true, "api"));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee18);
      }))();
    },
    fetchPickupAvailabilities: function fetchPickupAvailabilities() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee19$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this = _this19;
              _context20.next = 3;
              return request("/v1/shipping/orders/" + _this.order.id_order + "/pickup-availability", "get", null, true, "api").catch(function (e) {
                if (e.response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                } else {
                  _this.$toasted.show("Unable to get pickup availabilities.", {
                    type: "error"
                  });
                }
                throw e;
              });
            case 3:
              response = _context20.sent;
              _this19.slots = response.data;
              if (_this.order.shipment_date) _this.form.slots[_this.order.id_order] = new Date(_this.order.shipment_date).formatForDatePickerDays();
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee19);
      }))();
    },
    emptyDocuments: function emptyDocuments() {
      this.documents = [];
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee20$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this20.isLoadingFiles = true;
              _this = _this20;
              _context21.next = 4;
              return request("/v1/orders/" + _this20.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context21.sent;
              _this20.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this20.isLoadingFiles = false;
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee20);
      }))();
    },
    initStep: function initStep() {
      var _this21 = this;
      var stepCount = 1;
      if (this.isExportedToUSA && this.winesWithoutTtbId.length) {
        this.steps = [].concat(_toConsumableArray(this.steps), [{
          id: stepCount,
          key: "ttb",
          title: "Some TTB-ID not found!",
          inf: "Please fill the missing identifiers on the product sheet by clicking on each associated.",
          rules: [function () {
            return !_this21.winesWithoutTtbId.length;
          }]
        }]);
        stepCount++;
      }
      if (this.hasImporter) {
        var _this$importersAvaila;
        this.importerSelectorSelected = (_this$importersAvaila = this.importersAvailable.find(function (x) {
          var _this21$order$importe;
          return x.id == ((_this21$order$importe = _this21.order.importer) === null || _this21$order$importe === void 0 ? void 0 : _this21$order$importe.id);
        })) !== null && _this$importersAvaila !== void 0 ? _this$importersAvaila : this.importersAvailable[0];
        this.isSendNotificationMailsToImporter = !String.isNullOrEmpty(this.importerSelectorSelected.mailContact) && this.importerSelectorSelected.isDefaultReceiveEmails && this.order.user.user_group !== "USER";
        this.steps.push({
          id: stepCount++,
          key: "importer",
          title: "Importer",
          inf: "Please verify or select the right importer."
        });
      }
      this.availableOrders = [this.order];
      this.availableOrders.forEach(function (x) {
        if (_this21.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id) {
          _this21.steps = [].concat(_toConsumableArray(_this21.steps), [{
            id: stepCount,
            key: "pickup",
            title: "Plan a pickup",
            inf: "Please select a date to plan your pick-up.",
            data: x
          }]);
          stepCount++;
        }
      });
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "shipment",
        title: "Shipments",
        inf: "fill in the shipments information"
      }]);
      stepCount++;
      if (this.isContainerOrder) {
        this.steps = [].concat(_toConsumableArray(this.steps), [{
          id: stepCount,
          key: "containerSuborders",
          title: "Container suborders",
          inf: "Suborders status option"
        }]);
        stepCount++;
      }
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "mail",
        title: "Send custom e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: stepCount + 1,
        key: "synthesis",
        title: "Synthesis",
        data: this.availableOrders.reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.id_order, x));
        }, {})
      }]);
      this.form.slots = this.availableOrders.reduce(function (acc, x) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.id_order, x.shipment_date ? new Date(x.shipment_date).toISOString().substr(0, 10) : null));
      }, {});

      //Strange experience in some situations, prefer alwayse start to 1, and verify all datas
      //if (this.allSlotsOk.length === this.availableOrders.length) this.currentStep = stepCount
      this.currentStep = 1;
    },
    confirmPickup: function confirmPickup(slot) {
      var _this22 = this;
      if (!slot) {
        this.errorOccurred = true;
      } else {
        this.errorOccurred = false;
        this.confirmStep();
        setTimeout(function () {
          return _this22.changePanel();
        }, 200);
      }
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    shipmentsChanged: function shipmentsChanged(shipments) {
      var trackedShip = null;
      if ((shipments === null || shipments === void 0 ? void 0 : shipments.length) > 0) {
        trackedShip = shipments.find(function (x) {
          return x.tracked;
        }) || shipments[shipments.length - 1];
      }
      this.trackingNumberChanged(trackedShip);
      this.trackingUrlChanged(trackedShip);
      this.carrierNameChanged(trackedShip);
    },
    trackingNumberChanged: function trackingNumberChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "TrackingNumber";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber)) {
        var _shipment$trackingNum;
        placeholder.filledValue = (_shipment$trackingNum = shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber) !== null && _shipment$trackingNum !== void 0 ? _shipment$trackingNum : "";
      }
      this.trackingChanged(shipment);
    },
    trackingUrlChanged: function trackingUrlChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "TrackingUrl";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink)) {
        var _shipment$trackingLin;
        placeholder.filledValue = (_shipment$trackingLin = shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink) !== null && _shipment$trackingLin !== void 0 ? _shipment$trackingLin : "";
      }
      this.trackingChanged(shipment);
    },
    trackingChanged: function trackingChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "Tracking";
      });
      var value = "";
      if (!!(shipment !== null && shipment !== void 0 && shipment.trackingNumber)) {
        if (regexbAbsoluteUri.test(shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink)) {
          value = '<a href="' + (shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink) + '">' + (shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber) + "</a>";
        } else {
          value = shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber;
        }
      }
      placeholder.filledValue = value;
    },
    carrierNameChanged: function carrierNameChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "CarrierName";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.carrierName)) {
        var _shipment$carrierName;
        placeholder.filledValue = (_shipment$carrierName = shipment === null || shipment === void 0 ? void 0 : shipment.carrierName) !== null && _shipment$carrierName !== void 0 ? _shipment$carrierName : "";
      }
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this23 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this23.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    startEditImporter: function startEditImporter() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        return _regeneratorRuntime().wrap(function _callee21$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this24.isEditingImporter = true;
            case 1:
            case "end":
              return _context22.stop();
          }
        }, _callee21);
      }))();
    },
    saveChangeImporter: function saveChangeImporter() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this25$order$importe;
        var _this25$changeOrderIm, _this, data;
        return _regeneratorRuntime().wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!(((_this25$order$importe = _this25.order.importer) === null || _this25$order$importe === void 0 ? void 0 : _this25$order$importe.id) !== _this25.importerSelectorSelected.id)) {
                _context23.next = 9;
                break;
              }
              (_this25$changeOrderIm = _this25.changeOrderImporterCancellationToken) === null || _this25$changeOrderIm === void 0 || _this25$changeOrderIm.cancel();
              _this25.changeOrderImporterCancellationToken = axios.CancelToken.source();
              _this = _this25;
              data = {
                importerId: _this25.importerSelectorSelected.id
              };
              _context23.next = 7;
              return request("/v1/orders/" + +_this25.order.id_order + "/importer", "put", data, true, "api", null, _this25.changeOrderImporterCancellationToken).then(function (_) {
                _this.order.importer = _this.importersAvailable.find(function (x) {
                  return x.id === _this25.importerSelectorSelected.id;
                });
                _this.isEditingImporter = false;
                _this.isSendNotificationMailsToImporter = !String.isNullOrEmpty(_this25.importerSelectorSelected.mailContact) && _this25.importerSelectorSelected.isDefaultReceiveEmails && _this25.order.user.user_group !== "USER";
                _this.emptyDocuments();
                _this.fetchOrderDocuments();
                _this.$emit("sync", true, function () {});
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change importer");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this.isEditingImporter = false;
                }
              });
            case 7:
              _context23.next = 10;
              break;
            case 9:
              _this25.isEditingImporter = false;
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee22);
      }))();
    },
    wineNaming: wineNaming
  }
};